import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { Alert } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';

import { getProject } from 'features/project/projectSlice';
import {
  contentHubPath,
  filesPath,
  hypothesesListPath,
  reportsListPath,
} from 'common/services/urlService';

import styles from './PageHiddenAlert.module.scss';

const ROUTE_URLS = {
  [NavigationNodeId.ANALYSES]: (pid: string) => `/projects/${pid}/analyses`,
  [NavigationNodeId.CONTENT_HUB]: (pid: string) => contentHubPath(pid),
  [NavigationNodeId.FILES]: (pid: string) => filesPath(pid),
  [NavigationNodeId.KEY_FOCUS_AREAS]: (pid: string) => hypothesesListPath(pid),
  [NavigationNodeId.REPORTS]: (pid: string) => reportsListPath(pid),
};

export function PageHiddenAlert() {
  const project = useSelector(getProject);
  const location = useLocation();
  const { t } = useTranslation();
  const isHidden = useMemo(() => {
    const matchingId = Object.values(NavigationNodeId).find((id) => {
      const url = ROUTE_URLS[id](project.id);

      return location.pathname.startsWith(url);
    });

    if (!matchingId) return false;

    const nav = project.navigation?.find((i) => i.id === matchingId);

    return nav?.isHidden;
  }, [location.pathname, project.id, project.navigation]);

  if (!isHidden) return null;

  return (
    <div className={styles.pageHiddenAlertContainer}>
      <Alert
        type="info"
        closable={false}
        content={t('currentlyHidden')}
        className={styles.pageHiddenAlert}
      />
    </div>
  );
}

export default PageHiddenAlert;
